<template>
  <div class="sidebar-left">
    <div class="sidebar">
      <!-- Logged In User Profile Sidebar -->
      <!-- <user-profile-sidebar
        :shall-show-user-profile-sidebar="shallShowUserProfileSidebar"
        :profile-user-data="profileUserData"
        @close-sidebar="$emit('update:shall-show-user-profile-sidebar', false)"
      /> -->

      <!-- Sidebar Content -->
      <div class="sidebar-content" :class="{ show: mqShallShowLeftSidebar }">
        <!-- Sidebar close icon -->
        <span class="sidebar-close-icon">
          <feather-icon
            icon="XIcon"
            size="16"
            @click="$emit('update:mq-shall-show-left-sidebar', false)"
          />
        </span>

        <!-- Header -->
        <div class="chat-fixed-search">
          <div class="d-flex align-items-center w-100">
            <div class="sidebar-profile-toggle">
              <b-avatar
                size="42"
                class="cursor-pointer badge-minimal avatar-border-2"
                :src="user.ngo.logo"
                variant="transparent"
                @click.native="$emit('show-user-profile')"
              />
            </div>
            <!-- Search -->
            <!-- <form-autocomplete
              class="w-100 mx-1"
              :dir="'rtl'"
              :getOptionLabel="(x) => x.name_ar"
              :reduce="(x) => x.id"
              ep="v2/guest/filter-name"
              id="ngos"
              placeholder="ابدأ بالكتابة للبحث"
            /> -->
            <b-input-group class="input-group-merge ml-1 w-100 round">
              <b-input-group-prepend is-text>
                <feather-icon icon="SearchIcon" class="text-muted" />
              </b-input-group-prepend>
              <b-form-input v-model="searchQuery" placeholder="بحث..." />
            </b-input-group>
          </div>
        </div>

        <!-- ScrollArea: Chat & Contacts -->
        <vue-perfect-scrollbar
          :settings="perfectScrollbarSettings"
          class="chat-user-list-wrapper list-group scroll-area"
        >
          <!-- Chats Title -->
          <h4 class="chat-list-title">المحادثات</h4>
          <small
            v-show="filteredChatsContacts.length === 0"
            class="text-center text-secondary"
          >
            لا توجد محادثات حتى الآن
          </small>
          <!-- Chats -->
          <ul class="chat-users-list chat-list media-list">
            <chat-contact
              v-for="contact in filteredChatsContacts"
              :key="contact.id"
              :user="contact"
              tag="li"
              :class="{ active: activeChatContactId === contact.id }"
              is-chat-contact
              @click="$emit('open-chat', contact)"
            />
          </ul>

          <!-- Contacts Title -->
          <h4 class="chat-list-title">المنظمات</h4>

          <!-- Contacts -->
          <ul class="chat-users-list contact-list media-list">
            <chat-contact
              v-for="contact in filteredContacts"
              :key="contact.id"
              :user="contact"
              tag="li"
              @click="$emit('open-chat', contact)"
            />
          </ul>
        </vue-perfect-scrollbar>
      </div>
    </div>
  </div>
</template>

<script>
import {
  BAvatar,
  BInputGroup,
  BInputGroupPrepend,
  BFormInput,
} from "bootstrap-vue";
import VuePerfectScrollbar from "vue-perfect-scrollbar";
import { ref, computed } from "@vue/composition-api";
import ChatContact from "./ChatContact.vue";
import UserProfileSidebar from "./UserProfileSidebar.vue";
import { mapGetters } from "vuex";
import FormAutocomplete from "@/components/form-autocomplete/index.vue";
export default {
  components: {
    // BSV
    BAvatar,
    BInputGroup,
    BInputGroupPrepend,
    BFormInput,
    // 3rd party
    VuePerfectScrollbar,
    // SFC
    ChatContact,
    UserProfileSidebar,
    FormAutocomplete,
  },
  props: {
    chatsContacts: {
      type: Array,
      required: true,
    },
    contacts: {
      type: Array,
      required: true,
    },
    shallShowUserProfileSidebar: {
      type: Boolean,
      required: true,
    },
    profileUserData: {
      type: Object,
      required: true,
    },
    // profileUserMinimalData: {
    //   type: Object,
    //   required: true,
    // },
    activeChatContactId: {
      type: Number,
      default: null,
    },
    mqShallShowLeftSidebar: {
      type: Boolean,
      required: true,
    },
  },
  computed: {
    ...mapGetters("User", ["user"]),
  },
  setup(props) {
    const perfectScrollbarSettings = {
      maxScrollbarLength: 150,
    };

    const resolveChatContact = (userId) =>
      props.contacts.find((contact) => contact.id === userId);

    // Search Query
    const searchQuery = ref("");

    const searchFilterFunction = (contact) =>
      contact.name_ar.toLowerCase().includes(searchQuery.value.toLowerCase());
    const filteredChatsContacts = computed(() =>
      props.chatsContacts.filter(searchFilterFunction)
    );
    const filteredContacts = computed(() =>
      props.contacts.filter(searchFilterFunction)
    );

    return {
      // Search Query
      searchQuery,
      filteredChatsContacts,
      filteredContacts,

      // UI
      resolveChatContact,
      perfectScrollbarSettings,
    };
  },
};
</script>
